import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addAgreementNote } from '../services/agreementNotes';
import type { AddNoteInput } from '../types/agreementTimeline.types';
import { agreementKeys } from './agreementKeys';

export function useAddAgreementNoteMutation(id: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input: AddNoteInput) => addAgreementNote(id, input),
        /** A note appends a history event too, so both feeds go stale at once. */
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: agreementKeys.notes(id) });
            void queryClient.invalidateQueries({ queryKey: agreementKeys.history(id) });
        },
    });
}
